import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="avatar-preview"
export default class extends Controller {
  static targets = ["input", "preview"];

  connect() {
    if (this.hasInputTarget && this.hasPreviewTarget) {
      this.inputTarget.addEventListener("change", this.updatePreview.bind(this));
    }
  }

  updatePreview() {
    const file = this.inputTarget.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
}
